import { JSONPath } from 'jsonpath-plus';

// Helper function to reconstruct the filtered object
const deepSet = (obj, path, value) => {
  // Handle jsonpath-plus path format like "['results'][0]['_id']"
  const cleanPath = path
    .replace(/^\$\.?/, '') // Remove $. prefix
    .replace(/\['([^']+)'\]/g, '.$1') // Convert ['key'] to .key
    .replace(/\[(\d+)\]/g, '.$1') // Convert [0] to .0
    .replace(/^\./, ''); // Remove leading dot

  const parts = cleanPath.split('.');
  let curr = obj;

  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];
    if (!(part in curr)) {
      curr[part] = /^\d+$/.test(parts[i + 1]) ? [] : {};
    }
    curr = curr[part];
  }
  curr[parts.at(-1)] = value;
};

export const filterWithJsonPath = (data, paths) => {
  const filtered = {};

  for (const path of paths) {
    try {
      const matches = JSONPath({ path, json: data, resultType: 'all' });
      for (const match of matches) {
        deepSet(filtered, match.path, match.value);
      }
    } catch (error) {
      console.warn('Invalid JSONPath expression:', path, error);
    }
  }

  return filtered;
};
